// cleanup_hoc_to_hooks_GENERICS
// cleanup_convert_to_typescript_file_GENERICS
// cleanup_remove_inline_styles_GENERICS
// cleanup_convert_to_glu_component_GENERICS

import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';

import { CaretLeftIcon } from '@glu/icons-react';

import ErrorBoundary from 'components/errorBoundary';
import LocaleContext from 'components/locale/LocaleContext';
import { JSSClasses } from 'proptypes/jss-prop-types';
import { logEvent } from 'api/audits/service';
import withAppStyles from 'components/withAppStyles/withAppStyles';
import FormPrompt from 'components/withFormPrompt/FormPrompt';
import { DEFAULT_PROPS } from 'constants.js';

import styles from './workflow.styles';
import nativeStyles from './workflow.native.styles';

const { EMPTY_FUNCTION, EMPTY_OBJ } = DEFAULT_PROPS;
const WorkflowContext = createContext();

export const WorkflowComponent = ({
  allowNavigationFunc = null,
  children,
  className = '',
  classes: { backArrow, extraBox, footer, workflowHeader, workflowTitle, wrapper } = EMPTY_OBJ,
  'data-qa': dataQa = '',
  extra = null,
  extraStyleProps = EMPTY_OBJ,
  history,
  logTitle = true,
  onBack = null,
  onBackMove = EMPTY_FUNCTION,
  padHeader = false,
  prefix = '',
  prompt = false,
  returnUrl = '/',
  showFooter = true,
  title = ''
}) => {
  const [allowNavigation, setAllowNavigation] = useState(false);
  const locale = useContext(LocaleContext);
  const svgTitle = `${locale['common.leave']} ${title}`;

  useEffect(() => {
    if (!title) {
      const message = prefix || '';
      logEvent({ subSvc: locale['common.workflow'], message });
    }
    if (title && logTitle) {
      let message = title;
      if (prefix) {
        message = `${prefix} - ${title}`;
      }
      logEvent({ subSvc: locale['common.workflow'], message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  const goBack = () => {
    const url = history?.location?.state?.previous || returnUrl;
    onBackMove();
    history.push({ pathname: url });
  };
  return (
    <WorkflowContext.Provider value={{ setAllowNavigation }}>
      <div className={classnames('clearfix', className)} data-qa={dataQa}>
        <header className={workflowHeader}>
          <button
            className="btn btn-link"
            data-qa="returnButton"
            onClick={onBack || goBack}
            role="link"
            type="button"
          >
            <div className={backArrow}>
              <CaretLeftIcon alt="" role="none" title={svgTitle} />
            </div>
          </button>

          {/* inlining the style to override GluOverrides styles */}
          <h1
            className={workflowTitle}
            data-qa="workflow-title"
            style={{ marginBottom: 0, marginLeft: padHeader ? '60px' : 0 }}
          >
            {title}
          </h1>

          {extra && (
            <div className={extraBox} style={extraStyleProps}>
              {extra}
            </div>
          )}
        </header>
        <main className={wrapper} id="content">
          {prompt && (
            <FormPrompt
              allowNavigation={allowNavigation}
              allowNavigationFunc={allowNavigationFunc}
            />
          )}
          <ErrorBoundary>{children}</ErrorBoundary>
        </main>
        {showFooter && <div className={footer} />}
      </div>
    </WorkflowContext.Provider>
  );
};

WorkflowComponent.propTypes = {
  allowNavigationFunc: PropTypes.func,
  classes: JSSClasses,
  children: PropTypes.node.isRequired,
  extra: PropTypes.element,
  history: PropTypes.shape({}).isRequired,
  logTitle: PropTypes.bool,
  onBack: PropTypes.func,
  returnUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  title: PropTypes.string,
  'data-qa': PropTypes.string,
  prefix: PropTypes.string,
  prompt: PropTypes.bool,
  className: PropTypes.string,
  showFooter: PropTypes.bool,
  padHeader: PropTypes.bool,
  extraStyleProps: PropTypes.shape({}),
  onBackMove: PropTypes.func
};

const Styled = withAppStyles({ web: styles, native: nativeStyles }, WorkflowComponent);
export default withRouter(Styled);

export { WorkflowContext };
